<template>
  <div class="relationship-rule-container" :class="list.parent_id === null ? 'mt-5' : ''">
    <vs-row class="align-middle">
      <div v-if="list.number != 0" class="relationship-rule-kind mb-4" style="min-width: 5%">
          <div class="mt-8">
            <span>Tipo:</span>
          </div>
          <vs-chip class="mb-4 mt-2 w-full">
            <span>{{ list.type }}</span>
          </vs-chip>
      </div>
      <div class="relationship-rule-kind mb-4" style="min-width: 30%">
          <div class="mt-5">
            <span>Campo:</span>
          </div>

          <v-select
            class="w-full col" :value="list.relationship_condition_models_field_id" v-model="fieldSelected"
            :options="fields" id="id" label="name"
          >
            <template #option="{ name }">
                <div class="name">
                  {{name}}
                </div>
            </template>
          </v-select>
      </div>

      <div class="relationship-rule-kind mb-4" style="min-width: 10%">
          <div class="mt-5">
            <span>Operador:</span>
          </div>

          <v-select
            class="w-full col" :value="list.relationship_condition_models_operator_id" v-model="operatorSelected"
            :options="operators" id="id" label="name"
          >
            <template #option="{ name }">
                <div class="name">
                  {{name}}
                </div>
            </template>
          </v-select>
      </div>

      <div class="relationship-rule-kind mb-4" style="min-width: 30%">
          <div class="mt-5">
            <span>Tipo de Dado:</span>
          </div>

          <v-select
            class="w-full col" :value="list.relationship_condition_models_data_type_id" v-model="dataTypeSelected"
            :options="dataTypes" id="id" label="name"
          >
            <template #option="{ name }">
                <div class="name">
                  {{name}}
                </div>
            </template>
          </v-select>
      </div>

      <div class="relationship-rule-value">
        <vs-input
          v-validate="'required'"
          class="mb-4 pt-6 w-full"
          v-model="list.relationship_condition_models_value"
          label-placeholder="Valor"
          :name="'value' + index"
        />

        <span
          class="text-danger text-sm"
          v-show="errors.has('description'+index)"
        >
          Campo de preenchimento obrigatório
        </span>
      </div>

      <div class="relationship-rule-button">
        <div>
          <vs-dropdown vs-custom-content>
            <vs-button class="btn-drop mr-2" type="filled" icon="more_vert"></vs-button>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <div class="flex" @click.prevent="remove">
                  <feather-icon
                    class="ml-3 mr-2"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5  stroke-current"
                  />
                  <p class="ml-5">Remover</p>
                </div>
                <div v-if="list.number !== 0" class="flex mt-2" @click.prevent="group">
                  <feather-icon
                    class="ml-3 mr-2"
                    icon="ChevronsUpIcon"
                    svgClasses="w-5 h-5  stroke-current"
                  />
                  <p class="ml-5">Agrupar</p>
                </div>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </vs-row>
  </div>
</template>
<script>
  import requests from '@/http/requests/relationshipRuleConditionModels'

  import vSelect from 'vue-select'
  import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
  import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
  import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";

  export default {
    name: 'relationship-rules-form',
    components: { VsDropdownMenu, VsDropdown, VsDropdownItem, 'v-select': vSelect },
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      list: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        fields: [],
        operators: [],
        dataTypes: [],
        fieldSelected: null,
        operatorSelected: null,
        dataTypeSelected: null,
      }
    },
    async mounted () {
      await this.$store.dispatch('setShowLoadingOverlay', true)

      try {
      const fieldResponse = await requests.fetchWhere(0);
      this.fields = fieldResponse.data.data.getRelationshipRuleConditionModels

      const operatorResponse = await requests.fetchWhere(1)
      this.operators = operatorResponse.data.data.getRelationshipRuleConditionModels

      const dataTypeResponse = await requests.fetchWhere(2)
      this.dataTypes = dataTypeResponse.data.data.getRelationshipRuleConditionModels

      if (this.list.relationship_condition_models_field) {
        this.fieldSelected = this.list.relationship_condition_models_field
      }

      if (this.list.relationship_condition_models_operator) {
        this.operatorSelected = this.list.relationship_condition_models_operator
      }

      if (this.list.relationship_condition_models_data_type) {
        this.dataTypeSelected = this.list.relationship_condition_models_data_type
      }

      await this.$store.dispatch('setShowLoadingOverlay', false)
     } catch (error)  {
        await this.$store.dispatch('setShowLoadingOverlay', false)
        console.error(error)
      }
    },
    watch: {
      fieldSelected(item) {
        this.list.relationship_condition_models_field = item
        this.list.relationship_condition_models_field_id = item.id
      },
      operatorSelected(item) {
        this.list.relationship_condition_models_operator = item
        this.list.relationship_condition_models_operator_id = item.id
      },
      dataTypeSelected(item) {
        this.list.relationship_condition_models_data_type = item
        this.list.relationship_condition_models_data_type_id = item.id
      }
    },
    methods: {
      remove() {
        this.$emit('onRemoveRule', this.index)
      },
      group() {
        this.list['parent_id'] = true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .align-middle {
    align-items: center;
    justify-content: space-between;
  }

  .relationship-rule-container {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .relationship-rule-header {
    display: flex;
    align-items: center;
  }

  .relationship-rule-description {
    width: 60%;
    margin-top: 25px;

    @media(max-width: 899px) {
      width: 100%;
    }
  }

  .relationship-rule-button {
    margin-top: 27px;
  }

  .relationship-rule-items {
    margin-left: 20px;
  }
</style>



<style scoped>
  .icon-i {
    float: left;
    margin-right: 15px;
  }
</style>